/**
 * Sticky add-to-cart: single circular floating icon. Visible when [data-add-to-cart-ref]
 * scrolls out of view. Uses variant and quantity from the main product form.
 */
(function () {
  function findSection() {
    var bar = document.querySelector('[data-product-sticky-bar]');
    return bar ? bar.closest('.section-main-product') : null;
  }

  function init() {
    var section = findSection();
    if (!section) return;

    var ref = section.querySelector('[data-add-to-cart-ref]');
    var bar = section.querySelector('[data-product-sticky-bar]');
    var form = section.querySelector('[data-product-form]') || section.querySelector('form.product-form');
    if (!ref || !bar || !form) return;

    var variantInput = form.querySelector('[data-variant-input]');
    var quantityInput = form.querySelector('[data-quantity-input]');
    var stickyAdd = bar.querySelector('[data-sticky-add]');
    var fabBadge = bar.querySelector('[data-sticky-fab-badge]');

    function getQty() {
      if (!quantityInput) return 1;
      var q = parseInt(quantityInput.value, 10);
      return isNaN(q) || q < 1 ? 1 : Math.min(99, q);
    }

    function updateBadge() {
      if (!fabBadge) return;
      var q = getQty();
      var label = q > 1 ? (q > 99 ? '99+' : String(q)) : '+';
      fabBadge.textContent = label;
      fabBadge.hidden = false;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== ref) return;
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('product-sticky-bar-visible');
          } else {
            updateBadge();
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
            document.body.classList.add('product-sticky-bar-visible');
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(ref);

    if (quantityInput) {
      quantityInput.addEventListener('change', updateBadge);
      quantityInput.addEventListener('input', updateBadge);
    }

    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var errorEl = bar.querySelector('[data-sticky-add-error]') || section.querySelector('[data-product-form-error]');
        function showAddError(msg) {
          if (errorEl) {
            errorEl.textContent = msg || 'Unable to add to cart. Please try again.';
            errorEl.classList.remove('visually-hidden');
          }
        }
        var variantIdRaw = variantInput ? String(variantInput.value || '').trim() : '';
        var variantId = variantIdRaw ? parseInt(variantIdRaw, 10) : 0;
        if (!variantId || isNaN(variantId)) {
          showAddError('Please select a variant.');
          return;
        }
        var qty = getQty();
        var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart/add.js';
        stickyAdd.disabled = true;
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.add('visually-hidden');
        }
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        }).then(function (res) {
          return res.json().then(function (data) {
            stickyAdd.disabled = false;
            if (res.ok) {
              document.dispatchEvent(new CustomEvent('gaurya:minicart:open'));
            } else {
              var msg = (data && (data.description || data.message)) || 'This variant cannot be added. It may be sold out.';
              showAddError(msg);
            }
          });
        }).catch(function () {
          stickyAdd.disabled = false;
          showAddError('Something went wrong. Please try again.');
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-product-sticky-bar]')) {
      init();
    }
  });
})();
